import { useCallback, useState } from 'react';

import { ApiResponse } from 'services/api';
import { handleResponse } from 'utils/hooks/api/utils';

export const useInsightsResponseHandler = <QueryT>() => {
  const [data, setData] = useState<QueryT | undefined>();
  const [isRetrying, setIsRetrying] = useState(false);

  const responseHandler = useCallback((response: ApiResponse<QueryT>) => {
    setData(response.data);
    setIsRetrying(response.status === 206);
    return handleResponse(response);
  }, []);

  return {
    data,
    isRetrying,
    handleResponse: responseHandler,
  };
};
